import { baseApi } from './baseApi';

export const applicationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    candidateAlreadyExists: builder.mutation({
      query: ({ organizationId, values }) => ({
        url: `/organizations/${organizationId}/candidate_already_exist`,
        method: 'POST',
        body: values,
      }),
    }),
    submitApplication: builder.mutation({
      query: ({ organizationId, applicationData }) => ({
        url: `/organizations/${organizationId}/public_candidate`,
        method: 'POST',
        body: applicationData,
      }),
      invalidatesTags: ['Candidate', 'UserResumes'],
    }),
    createCandidate: builder.mutation({
      query: ({ organizationId, applicationData }) => ({
        url: `/organizations/${organizationId}/candidates`,
        method: 'POST',
        body: applicationData,
      }),
      invalidatesTags: ['Candidate', 'UserResumes'],
    }),
    generalQuestion: builder.mutation({
      query: (questionData) => ({
        url: `/general_question`,
        method: 'PUT',
        body: questionData,
      }),
      invalidatesTags: ['Candidate'],
    }),
    getCandidate: builder.query({
      query: ({ organizationId, applicationId }) => ({
        url: `/organizations/${organizationId}/candidates/${applicationId}`,
      }),
      providesTags: ['Candidate'],
    }),
    applyOnReferredJob: builder.mutation({
      query: ({ applicationData }) => ({
        url: `/applicants/sign_up`,
        method: 'POST',
        body: applicationData,
      }),
    }),
  }),
});

export const {
  useSubmitApplicationMutation,
  useCandidateAlreadyExistsMutation,
  useGeneralQuestionMutation,
  useCreateCandidateMutation,
  useGetCandidateQuery,
  useApplyOnReferredJobMutation,
} = applicationApi;
